import { PeekChip, PeekGrid, PeekTypography } from "@piiqtechnologies/ui-components";
import React from "react";
const getCommunityLabel = (values, valueId) => {
    var _a;
    return (_a = values.find((value) => value._id === valueId)) === null || _a === void 0 ? void 0 : _a.name;
};
const SelectedValue = ({ selected, placeholder, values, removeSelected, toggleSelectProperties, hideValues, }) => {
    if (!(selected === null || selected === void 0 ? void 0 : selected.length) || hideValues) {
        return (React.createElement(PeekTypography, { variant: "h5", color: "text.disabled", width: "100%", onClick: toggleSelectProperties, lineHeight: "28px" }, placeholder));
    }
    return (React.createElement(PeekGrid, { container: true, spacing: 0.25, onClick: toggleSelectProperties }, selected === null || selected === void 0 ? void 0 :
        selected.map((valueId, index) => (React.createElement(PeekGrid, { item: true, key: index },
            React.createElement(PeekChip, { size: "small", clickable: true, label: getCommunityLabel(values, valueId), onDelete: () => {
                    removeSelected(valueId);
                }, sx: { backgroundColor: "grey.400", "& .MuiChip-deleteIcon": { color: "text.primary" } } })))),
        React.createElement(PeekGrid, { item: true, key: "default" },
            React.createElement(PeekTypography, { variant: "h5", color: "text.disabled", lineHeight: "23px" }, placeholder))));
};
export default SelectedValue;
